module.exports = __webpack_public_path__ + "static/media/icon_close@3x.1bb477a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_close@3x.png
// module id = 1771
// module chunks = 0 1